import { createSelector } from 'reselect'
import { hasPermission, PermissionLevels } from 'utils/permission'

export const getLayout = (state, props) => {
  return state['view-home'].layouts.byId[props.layoutId]
}

export const getLayoutPermissionLevel = (state, props) => {
  return state['view-home'].layoutPermissions[props.layoutId]
}

export default () => createSelector(
  [getLayoutPermissionLevel],
  (permissionLevel = PermissionLevels.NONE) => {
    return {
      visitor: hasPermission(permissionLevel, PermissionLevels.VISITOR),
      member: hasPermission(permissionLevel, PermissionLevels.MEMBER),
      owner: hasPermission(permissionLevel, PermissionLevels.OWNER)
    }
  }
)
